import React, { useState, ReactNode, useEffect } from 'react';
import {
  Link as RouterLink,
  useNavigate,
  useLocation,
  Location,
  useParams,
} from 'react-router-dom';
import {
  Button,
  Menu,
  MenuItem,
  Popover,
  Radio,
  Select,
  TextField,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  logout,
  Expand,
  formlogo,
  Collaps_Form_Logo,
  refresh,
  avatar,
  notification,
  logoutpopup,
  auditlogpopup,
  auditlogpopupactive,
  editprofilepopup,
  editprofileactivepopup,
} from '../../assets/images/index';
import userProfile from '../../../src/assets/images/userProfile.svg';
import Sidebar from '../auth/sidebar';
import { BorderAll, CheckBox } from '@mui/icons-material';
import { ReactComponent as SearchIcon } from '../../assets/images/Search.svg';
import USCountryCode from '../../assets/images/US_countryCode.svg';
import FJCountryCode from '../../assets/images/FJ_CountryCode.svg';
import UCountryCode from '../../assets/images/UCountryCode.svg';
import ENCountryCode from '../../assets/images/ENCountryCode.svg';
import SACountryCode from '../../assets/images/SACountryCode.svg';
import { useSelector } from 'react-redux';
import { useHook as globalAlertHook } from '../auth/alert/useHook';
import createAxiosInstance from '../../api';

type CustomLocation = Location;

export interface MenuItem {
  label: string;
  icon: React.ReactElement;
  subMenu?: SubMenuItem[];
  submenuitems: string[];
  to?: string;
  route: string;
  id?: string;
  activeMenuIcon: React.ReactElement;
}

interface SubMenuItem {
  label: string;
  menu: string;
  permissionname: string;
  icon: (isActive: boolean) => React.ReactElement;
  to: string;
  id?: string;
}

interface AuthLayoutProps {
  children: ReactNode;
  Header_text?: string;
  pagename?: string;
  initialRoute?: string;
  userDetails?: UserDetails;
  pagepermission: MenuItem[];
  intialRouteto?: string;
  secoundHome?: string;
  secoundInitialRouteto?: string;
  refreshAccess?: boolean;
}

interface UserDetails {
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
  roles: string[];
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  Header_text,
  pagename,
  initialRoute,
  userDetails,
  pagepermission,
  intialRouteto,
  secoundHome,
  secoundInitialRouteto,
  refreshAccess,
}) => {
  const location: CustomLocation = useLocation();
  const { name, id } = useParams();
  const navigate = useNavigate();
  const { fetchGlobalAlert } = globalAlertHook();
  const axiosInstance = createAxiosInstance();
  const token = localStorage.getItem('ICEMAKE');

  const [profileDropDown, setProfileDropDown] = useState(false);
  const [activeMenu, setActiveMenu] = useState('');
  const [collapseView, setCollapseView] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({
    value: 'US',
    imgURL: USCountryCode,
  });
  const [filteredCountry, setFilteredCountry] = useState<any>([]);
  const [searchCountryText, setSearchCountryText] = useState('');
  const { customerInformation } = useSelector(
    (state: any) => state.profileManagement,
  );
  const countryCodeData = [
    { value: 'FJ', imgURL: FJCountryCode },
    { value: 'U', imgURL: UCountryCode },
    { value: 'EN', imgURL: ENCountryCode },
    { value: 'US', imgURL: USCountryCode },
    { value: 'SA', imgURL: SACountryCode },
  ];
  const [alertList, setAlertList] = useState([]);

  const getGlobalAlertData = async (data?: any) => {
    const payload = {
      filters: {
        isUnread: 'true',
      },
      limit: 100,
      offset: 0,
    };
    await fetchGlobalAlert(payload).then((res: any) => {
      if (res?.data) {
        setAlertList(res?.data);
      }
    });
  };

  const handleSelectCountry = (value: string, imgURL: string) => {
    setSelectedCountry({
      value: value,
      imgURL: imgURL,
    });
  };

  const handleCountrySearch = (searchData: string) => {
    setSearchCountryText(searchData);
    const searchCountryCode = countryCodeData.filter((data) =>
      data.value.toLocaleLowerCase().includes(searchData.toLocaleLowerCase()),
    );
    setFilteredCountry(searchCountryCode);
  };

  useEffect(() => {
    setFilteredCountry(countryCodeData);
    getGlobalAlertData();
  }, []);

  const pageName = location?.pathname?.split('/')[1];

  useEffect(() => {
    if (pageName == 'auditlogupdate') {
      setActiveMenu('AuditLog');
    } else if (pageName == 'editProfile') {
      setActiveMenu('MyAccount');
    } else {
      setActiveMenu('');
    }
  }, [pageName, activeMenu]);

  useEffect(() => {
    setProfileDropDown(false);
  }, [pageName]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const profileManagement = () => {
    navigate('/profilemanagement/personaldetails');
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let childRefreshFunction: () => void;

  const setChildRefreshFunction = (refreshFunc: () => void) => {
    childRefreshFunction = refreshFunc;
  };

  const handleRefreshClick = () => {
    if (childRefreshFunction) {
      childRefreshFunction(); // Trigger the child component's refresh function
    }
  };
  const handleAlertMessage = () => {
    navigate('/alert');
  };

  const logout = async () => {
    try {
      const res = await axiosInstance.post('/customers/logout', {
        firebaseToken: token,
      });
      console.log(res, 'resres');
      if (res?.data?.success) {
        localStorage.clear();
        handleClose();
        setActiveMenu('LogoOut');
        navigate('/customerLogin');
        setProfileDropDown(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="non-auth_layout container-fluid">
        <div className="row non-auth_layout-row">
          <nav
            className={`${collapseView ? 'col-md-1 cpllapse_sidemenu_container' : 'col-md-2'} d-none d-md-block bg-light p-0 sidebar`}
          >
            <div
              className={`sidebar-header ${collapseView && 'collapseview_sidebar-header'}`}
            >
              <img
                src={collapseView ? Collaps_Form_Logo : formlogo}
                alt="Logo"
                width={collapseView ? 48 : 140}
              />
              {/* <Button
                className="img-background"
                onClick={() => setCollapseView(!collapseView)}
              >
                <img
                  src={collapseView ? Expand : logout}
                  alt="Logo"
                  width={25}
                  height={25}
                />
              </Button> */}
            </div>
            <div className="sidebar-menu-list">
              <Sidebar
                pagepermission={pagepermission}
                collapseView={collapseView}
              />
              {profileDropDown ? (
                <div className="sidebar_logout-popup">
                  <div className="logout_popup">
                    <Button
                      className={
                        activeMenu == 'MyAccount' ? 'option_active' : 'option'
                      }
                      onClick={() => {
                        setActiveMenu('MyAccount');
                        navigate('/editProfile');
                        setProfileDropDown(false);
                      }}
                    >
                      <img
                        src={
                          activeMenu == 'MyAccount'
                            ? editprofileactivepopup
                            : editprofilepopup
                        }
                        alt="edit profile"
                        width={24}
                        height={24}
                      />
                      <p
                        className={
                          activeMenu == 'MyAccount'
                            ? 'logout_popup_text_active'
                            : 'logout_popup_text'
                        }
                      >
                        My Account
                      </p>
                    </Button>
                    <Button
                      className={
                        activeMenu == 'AuditLog' ? 'option_active' : 'option'
                      }
                      onClick={() => {
                        setActiveMenu('AuditLog');
                        navigate('/auditlogupdate');
                        setProfileDropDown(false);
                      }}
                    >
                      <img
                        src={
                          activeMenu == 'AuditLog'
                            ? auditlogpopupactive
                            : auditlogpopup
                        }
                        alt="edit profile"
                        width={24}
                        height={24}
                      />
                      <p
                        className={
                          activeMenu == 'AuditLog'
                            ? 'logout_popup_text_active'
                            : 'logout_popup_text'
                        }
                      >
                        Audit Log
                      </p>
                    </Button>
                    <Button
                      className={
                        activeMenu == 'LogoOut' ? 'option_active' : 'option'
                      }
                      onClick={() => {
                        localStorage.clear();
                        setActiveMenu('LogoOut');
                        navigate('/customerLogin');
                        setProfileDropDown(false);
                      }}
                    >
                      <img
                        src={logoutpopup}
                        alt="edit profile"
                        width={24}
                        height={24}
                      />
                      <p
                        className={
                          activeMenu == 'LogoOut'
                            ? 'logout_popup_text_active'
                            : 'logout_popup_text'
                        }
                      >
                        Log Out
                      </p>
                    </Button>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            <hr className="m-0 mx-3" />
            <div className="sidebar-footer">
              <div className="d-flex align-items-center">
                <button
                  onClick={profileManagement}
                  style={{ border: 'none', background: 'none', padding: 0 }}
                >
                  <img
                    src={customerInformation?.image || userProfile}
                    className="sidebar-footer-avatar"
                    alt="userProfile"
                    width={36}
                    height={36}
                  />
                </button>
                {!collapseView && (
                  <div className="profile-details">
                    <p className="m-0 profile-name">
                      {/* {userDetails?.firstName + ' ' + userDetails?.lastName} */}
                      {Object.keys(customerInformation)?.length
                        ? `${customerInformation?.firstName || ''} ${customerInformation?.lastName || ''}`
                        : ''}
                    </p>
                    <p className="m-0 profile-type text-capitalize">
                      {userDetails?.roles ? userDetails?.roles[0] : []}
                    </p>
                  </div>
                )}
              </div>
              <Button
                className="border-0 MoreVert"
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={(event) => {
                  // setProfileDropDown(!profileDropDown);
                  handleClick(event);
                  setActiveMenu('');
                }}
              >
                <MoreVertIcon color="action" fontSize="small" />
              </Button>
            </div>
          </nav>

          <main role="main" className={`col  ml-sm-auto  px-4 main-content`}>
            <div className="main-header d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
              <div>
                <h4 className="h4 m-0">
                  <b>
                    {Header_text === 'id'
                      ? name?.replace(/_/g, ' ')
                      : Header_text}
                  </b>
                </h4>
                <Breadcrumbs className="bread-crumbs" aria-label="breadcrumb">
                  <Link
                    underline="hover"
                    color="inherit"
                    component={RouterLink}
                    to="/equipment/ownedequipment"
                  >
                    Home
                  </Link>
                  {secoundHome && secoundInitialRouteto && (
                    <Link
                      underline="hover"
                      color="inherit"
                      component={RouterLink}
                      to={secoundInitialRouteto}
                    >
                      {secoundHome}
                    </Link>
                  )}
                  {pagename && initialRoute && intialRouteto && (
                    <Link
                      underline="hover"
                      color="inherit"
                      component={RouterLink}
                      to={intialRouteto}
                    >
                      {initialRoute}
                    </Link>
                  )}
                  <Typography
                    color="text.primary"
                    className="breadcrumb_nonlink"
                    fontWeight={500}
                  >
                    {Header_text === 'id'
                      ? name?.replace(/_/g, ' ')
                      : Header_text}
                  </Typography>
                </Breadcrumbs>{' '}
              </div>
              <div className="d-flex justify-content-center align-items-center">
                {/* <div className="header_country_select_container">
                  <Select
                    multiple
                    value={[]}
                    displayEmpty
                    className="header_country_select"
                    renderValue={() => (
                      <div className="country_code_value-container">
                        <img src={selectedCountry.imgURL} alt="CountryCode" />
                        {selectedCountry.value}
                      </div>
                    )}
                  >
                    <div className="header_country_select_card">
                      <div className="header_country_select_card-search">
                        <TextField
                          fullWidth
                          InputProps={{ startAdornment: <SearchIcon /> }}
                          placeholder="Search"
                          value={searchCountryText}
                          onChange={(e) => handleCountrySearch(e.target.value)}
                        />
                      </div>
                      <div className="header_country_select_card-option_container">
                        {filteredCountry?.map((country: any, index: number) => {
                          console.log(country, 'countrycountry');
                          return (
                            <>
                              <Button
                                key={index}
                                className="header_country_select_card-option"
                                onClick={() =>
                                  handleSelectCountry(
                                    country.value,
                                    country.imgURL,
                                  )
                                }
                              >
                                <div className="header_country_select_card-option-img">
                                  <img src={country.imgURL} alt="CountryCode" />{' '}
                                  <span className="country_border">|</span>{' '}
                                  <span className="country_text">
                                    {country.value}
                                  </span>
                                </div>
                                <Radio
                                  checked={
                                    selectedCountry.value === country.value
                                  }
                                />
                              </Button>
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </Select>
                </div> */}
                {/* {pageName !== 'alert' && ( */}
                <Button
                  className="border-color-custom notification-btn"
                  onClick={handleAlertMessage}
                >
                  <img src={notification} alt="Logo" width={24} height={24} />
                  {alertList?.length > 0 && (
                    <div className="notifiction_indicator"></div>
                  )}
                </Button>
                {/* )} */}
                {refreshAccess && (
                  <Button
                    className="border-0 refresh-btn"
                    onClick={handleRefreshClick}
                  >
                    <img
                      className="rounded-circle"
                      src={refresh}
                      alt="Logo"
                      width={36}
                      height={36}
                    />
                  </Button>
                )}
              </div>
            </div>
            {React.cloneElement(children as React.ReactElement, {
              setRefreshFunction: setChildRefreshFunction,
              getGlobalAlertData: getGlobalAlertData,
            })}
          </main>
        </div>
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        sx={{
          '& .MuiMenu-paper': {
            bottom: '15%',
            left: '15px !important',
            top: 'auto !important',
          },
        }}
      >
        <div className="sidebar_logout-popup">
          <div className="logout_popup">
            <Button
              className={activeMenu == 'MyAccount' ? 'option_active' : 'option'}
              onClick={() => {
                handleClose();
                setActiveMenu('MyAccount');
                //navigate('/editProfile');
                navigate('/profilemanagement/personaldetails');
                setProfileDropDown(false);
              }}
            >
              <img
                src={
                  activeMenu == 'MyAccount'
                    ? editprofileactivepopup
                    : editprofilepopup
                }
                alt="edit profile"
                width={24}
                height={24}
              />
              <p
                className={
                  activeMenu == 'MyAccount'
                    ? 'logout_popup_text_active'
                    : 'logout_popup_text'
                }
              >
                My Account
              </p>
            </Button>

            {/* <Button
              className={activeMenu == 'AuditLog' ? 'option_active' : 'option'}
              onClick={() => {
                handleClose();
                setActiveMenu('AuditLog');
                navigate('/auditlogupdate');
                setProfileDropDown(false);
              }}
            >
              <img
                src={
                  activeMenu == 'AuditLog' ? auditlogpopupactive : auditlogpopup
                }
                alt="edit profile"
                width={24}
                height={24}
              />
              <p
                className={
                  activeMenu == 'AuditLog'
                    ? 'logout_popup_text_active'
                    : 'logout_popup_text'
                }
              >
                Audit Log
              </p>
            </Button> */}

            <Button
              className={activeMenu == 'LogoOut' ? 'option_active' : 'option'}
              onClick={logout}
            >
              <img
                src={logoutpopup}
                alt="edit profile"
                width={24}
                height={24}
              />
              <p
                className={
                  activeMenu == 'LogoOut'
                    ? 'logout_popup_text_active'
                    : 'logout_popup_text'
                }
              >
                Log Out
              </p>
            </Button>
          </div>
        </div>
      </Menu>
    </>
  );
};

export default AuthLayout;
